import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../../infra/hooks";

import { dashboardService } from "../../../../api/services/dashboardService";
import { setCalendarData } from "../../../../infra/aggregates/dashboardCalendarSlice";

function DTODashboardCalendar() {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  async function getCalendarDetails(companyId: number, empId: number) {
    const response: any = await dashboardService.getDashboardCalendarData(
      companyId,
      empId
    );
    if (response) {
      //dispatch(setCalendarData(response?.data));
    } else {
      return;
    }
  }
  useEffect(() => {
    if (selector) {
      getCalendarDetails(
        selector.authSlice.company_id,
        selector.authSlice.emp_id
      );
    }
  }, []);
  return <></>;
}
export default DTODashboardCalendar;
